import { ETheme } from "@/DependenciesV9";
import { NavDrawerBody, NavDrawerBodyProps } from "@fluentui/react-nav-preview";

interface NavDrawerBodyCustomProps extends NavDrawerBodyProps {
  rcName?: string;
  theme?: ETheme;
}

const NavDrawerBodyCustom = (props: NavDrawerBodyProps & NavDrawerBodyCustomProps) => {
  return <NavDrawerBody {...props}/>
};

export default NavDrawerBodyCustom;